import { expressQuerySelectorAll, expressEventListener, expressQuerySelector } from "../../common/html";
import { compositeDisposable } from "../../utils/disposable";
import { createPopup, IPopup } from "./popup-new";

export interface ILeavePageWatcher {
	start: () => void;
	cancel: () => void;
	stop: () => void;
}
export function CreateLeavePageWatcher(): ILeavePageWatcher {
	let paused = false;
	const leavePageDisposible = compositeDisposable([]);

	const start = () => {
		leavePageDisposible.dispose();
		paused = false;

		const links = expressQuerySelectorAll(document, "a:not(.technical-continue-button)");
		leavePageDisposible.addMany(
			links.map((x) => {
				return expressEventListener(x, "click", (e: Event) => {
					if (paused) return;
					if (e.currentTarget instanceof HTMLAnchorElement == false) return;
					const url = e.currentTarget.href;
					if (!url) return;

					e.preventDefault();
					e.stopPropagation();
					createPopup({
						dialogId: "LeavePageConfirmDialog",
						view: "ConfirmDialog",
						data: {
							Title: "Label.LeavePage.Title",
							Question: "Label.LeavePage.Message",
						},
						onClose: (_) => leavePageDisposible.dispose(),
					}).then((popup: IPopup) => {
						const okButton = expressQuerySelector<HTMLElement>(
							popup.popup,
							".technical-remove-confirmation-yes-button",
						);
						const cancelButton = expressQuerySelector<HTMLElement>(
							popup.popup,
							".technical-remove-confirmation-no-button",
						);

						leavePageDisposible.addMany([
							expressEventListener(okButton, "click", () => {
								window.location.href = url;
							}),
							expressEventListener(cancelButton, "click", () => {
								popup.close();
							}),
						]);
						popup.openAsync();
					});
				});
			}),
		);
	};

	return {
		start,
		stop: () => leavePageDisposible.dispose(),
		cancel: () => (paused = true),
	};
}
